module.exports = __webpack_public_path__ + "static/media/icons-ic-calendar-time-off-rejected.39ee164c.svg";